import { QUIZ_CATEGORIES } from "~/constants/questionnaire";
import { PRODUCT } from "~/constants/products";
import { PRODUCT_META_PIXELS } from "~/constants/metaPixels";

export type QuizTracking = {
    pixels: string[];
    productName: string;
};

/**
 * Maps a quiz category to the product family it reports for tracking. This
 * adapter is quiz-only — categories like `FACE_CREAM_REDESIGN` or
 * `OESTRA_ENDO_PRE_PURCHASE` mean nothing outside the funnel. The pixel table
 * it feeds into (`PRODUCT_META_PIXELS`) is the shared marketing concern and
 * lives in `~/constants/metaPixels`.
 */
const QUIZ_CATEGORY_TO_PRODUCT: Record<string, string> = {
    [QUIZ_CATEGORIES.OESTRA_ENDO_PRE_PURCHASE]: PRODUCT.OESTRA_CREAM,
    [QUIZ_CATEGORIES.OESTRA_CREAM]: PRODUCT.OESTRA_CREAM,
    [QUIZ_CATEGORIES.OESTRA_POSTPARTUM_PRE_PURCHASE]: PRODUCT.OESTRA_CREAM,
    [QUIZ_CATEGORIES.BIOIDENTICAL_HRT]: PRODUCT.OESTRA_CREAM,
    [QUIZ_CATEGORIES.LIBIDA]: PRODUCT.LIBIDA,
    [QUIZ_CATEGORIES.FACE_CREAM]: PRODUCT.FACE_CREAM,
    [QUIZ_CATEGORIES.FACE_CREAM_REDESIGN]: PRODUCT.FACE_CREAM,
    [QUIZ_CATEGORIES.NAD]: PRODUCT.NAD,
};

/**
 * Resolves the Meta tracking pixels and Pinterest product name for a quiz
 * category. Shared by every quiz variant (`components/Quiz`,
 * `componentsDS/Quiz`, `componentsDS/QuizRedesign`) and by `useWaitlist`. An
 * unknown category yields no pixels and an empty product name.
 */
export const resolveQuizTracking = (category: string): QuizTracking => {
    const productName = QUIZ_CATEGORY_TO_PRODUCT[category] ?? "";
    // Copy the array — `PRODUCT_META_PIXELS` is a shared constant and callers
    // must not be able to mutate it through the returned `pixels`.
    const pixels = productName ? [...(PRODUCT_META_PIXELS[productName] ?? [])] : [];
    return { pixels, productName };
};
